import { PropsWithChildren } from "react";
import api, { ApiContext } from "./api";

const ApiProvider = ({
    children
}: PropsWithChildren) => {

    return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
}

export default ApiProvider; //